<nf-table-layout
  tableTitle="Execution"
  class="nodes-table-layout"
  [autoResizeGrid]="false"
  [data]="uiNodes"
  [gridOptions]="gridOptions"
  hideSearch
  hideClearAll
  hideTitle
></nf-table-layout>
